import React from 'react';

class StreamerProfilePicture extends React.Component {
	render () {
		// Par défaut on considere qu'il n'y a pas de lien
		let CSSClass = "no-pointer";
		let hrefLink = null;

		// S'il y a un lien
		if (this.props.streamURL !== false) {
			CSSClass = null;
			hrefLink = this.props.streamURL;
		}

		return (
			<div className="col txtmiddle w80p col-mobile">
				<a href={hrefLink} className={CSSClass}
					target="_blank">
					<img src={this.props.streamImg} 
						className="blocRond" />
				</a>
			</div>
		);
	}
}

export default StreamerProfilePicture;